import { EntityState } from "@ngrx/entity";

import { ContributionEntity } from '../entities';
import { CreateContributionApiModel } from "@modules/story/models/api-models/input";
import { StoryStepViewModel } from "@modules/story/models/view-models";


export interface ContributionState extends EntityState<ContributionEntity> {
    isLoading: boolean,
    isLoaded: boolean,
    selectedId: number,
    contributionBuilderData: CreateContributionApiModel,
    stepActived: StoryStepViewModel,
    stepCompleted: number[]
}